export default __webpack_public_path__ + "static/assets/arrow.12580563.svg";